import type { RadioProps } from '@mui/material/Radio';
import MuiRadio from '@mui/material/Radio';
import { forwardRef } from 'react';

const Radio = forwardRef<HTMLButtonElement, RadioProps>((props, ref) => {
  return <MuiRadio ref={ref} {...props} />;
});

Radio.displayName = 'Radio';
export default Radio;
